import { inferAdditionalFields } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

export const authClient = createAuthClient({
  basePath: '/api/auth',
  plugins: [
    inferAdditionalFields({ user: { stripeCustomerId: { type: 'string', required: false } } }),
  ],
});

export function authErrorMessage(
  e: { message?: string; code?: string } | null | undefined,
  fallback = 'Something went wrong',
) {
  if (!e) return fallback;
  return e.message || fallback;
}
